import { render, staticRenderFns } from "./ViewProducts.vue?vue&type=template&id=2c5d7c08&scoped=true"
import script from "./ViewProducts.vue?vue&type=script&lang=js"
export * from "./ViewProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5d7c08",
  null
  
)

export default component.exports